<div (click)="toggleFlyout()">
	<ng-content></ng-content>
</div>

<ng-template cdk-portal>
	<div class="linq-drawer-content">
		<header class="linq-drawer-header">
			<h3 class="linq-heading">{{ header }}</h3>
			<button class="linq-drawer-header__close linq-button-close-lg" (click)="closeFlyout()">
				<mat-icon>clear</mat-icon>
			</button>
		</header>
		<div class="linq-drawer-inner-content linq-drawer-inner-content--spaced">
			<mat-tab-group [selectedIndex]="selectedTabIndex" class="mat-tab-all-height" #matTabGroup="matTabGroup">
				<mat-tab label="COPY ACCOUNT">
					<form (ngSubmit)="copyAccountForm.valid && copyAccount()" #copyAccountForm="ngForm">
						<div class="flyout-inner-container row">
							<div class="col-xs-12 linq-mb-4">
								<shared-message-list [messages]="copyAccountMessageList"></shared-message-list>
							</div>
							<div class="col-xs-12">
								<mat-form-field>
									<mat-label>New Account #</mat-label>
									<input matInput name="accountNumber" #number="ngModel" [mask]="unifiedAccountMask" [showMaskTyped]="true"
										[patterns]="accountPattern" [dropSpecialCharacters]="false" required [(ngModel)]="accountNumber" />
									<mat-error *ngIf="sameAccountNumber()">Must be modified for new account creation.</mat-error>
									<mat-error *ngIf="number?.errors?.required">Account # is required</mat-error>
									<mat-error *ngIf="number?.errors?.mask">Template is incomplete</mat-error>
								</mat-form-field>
							</div>
							<div class="col-xs-12">
								<mat-form-field>
									<mat-label>Description</mat-label>
									<input matInput name="description" #descriptionModel="ngModel" requiredNoWhitespace [(ngModel)]="description" />
									<mat-error *ngIf="descriptionModel?.errors?.required">Description is required</mat-error>
								</mat-form-field>
							</div>
							<div class="col-xs-12" *ngIf="false"> <!-- Temporarily hidden | LSB does not use parent accounts as of yet -->
								<mat-form-field>
									<mat-label>Parent Account #</mat-label>
									<input matInput name="parentAccountNumber" #parentAccountNumberModel="ngModel" [mask]="unifiedAccountMask"
										[showMaskTyped]="true" [patterns]="accountPattern" [dropSpecialCharacters]="false" required
										[(ngModel)]="parentAccountNumber" />
									<mat-error *ngIf="parentAccountNumberModel?.errors?.required">Parent Account # is required</mat-error>
									<mat-error *ngIf="parentAccountNumberModel?.errors?.mask">Template is incomplete</mat-error>
								</mat-form-field>
							</div>
							<div class="col-xs-12">
								<mat-form-field>
									<mat-label>Select Roles</mat-label>
									<mat-select name="SelectedUserRoleIds" required #SelectedUserRoleIdsModel="ngModel"
										[(ngModel)]="selectedUserRoleIds" multiple>
										<mat-select-trigger [innerHtml]="getRolesMultiSelectDisplayText()"></mat-select-trigger>
										<mat-option [value]="allUserRolesId" (click)="toggleAllRolesSelections()">Select All</mat-option>
										<mat-option *ngFor="let option of userRoles; trackById" [value]="option.Id" (click)="checkRoleOption()">
											{{ option.NameToDisplay }}
										</mat-option>
									</mat-select>
									<mat-error *ngIf="SelectedUserRoleIdsModel?.errors?.required">Roles is required</mat-error>
								</mat-form-field>
							</div>
						</div>
					</form>
				</mat-tab>
				<mat-tab label="COPY TO SITES">
					<form (ngSubmit)="copyToSitesForm.valid && copyToSites()" #copyToSitesForm="ngForm">
						<div class="flyout-inner-container row">
							<div class="col-xs-12 linq-mb-4">
								<shared-message-list [messages]="copyToSitesMessageList"></shared-message-list>
							</div>
							<div class="col-xs-12">
								<mat-form-field>
									<mat-label>Select Sites</mat-label>
									<mat-select name="SelectedSiteCodeIds" #SelectedSiteCodeIds="ngModel" [(ngModel)]="selectedSiteCodeIds" multiple>
										<mat-select-trigger [innerHtml]="getSitesMultiSelectDisplayText()"></mat-select-trigger>
										<mat-option [value]="allSiteCodesId" (click)="toggleAllSitesSelections()">Select All</mat-option>
										<mat-option *ngFor="let option of siteCodes; trackById" [value]="option.Id" [disabled]="option.Disabled"
											matTooltip="Site Code does not adhere to account structure" [matTooltipDisabled]="!option.Disabled"
											(click)="checkSiteOption()">
											{{ option.SiteCode }} - {{ option.SiteName }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-xs-12" *ngIf="false"> <!-- Temporarily hidden | LSB does not use parent accounts as of yet -->
								<mat-slide-toggle class="baseAccountIsParent linq-slide-toggle" color="primary" [ngModel]="baseAccountIsParent"
									(change)="toggleBaseAccount()" name="baseAccountIsParent">
									Base Account is Parent Account
								</mat-slide-toggle>
							</div>
							<div class="col-xs-12">
								<mat-form-field>
									<mat-label>Select Roles</mat-label>
									<mat-select name="SelectedUserRoleIds" #SelectedUserRoleIds="ngModel" [(ngModel)]="selectedUserRoleIds" multiple>
										<mat-select-trigger [innerHtml]="getRolesMultiSelectDisplayText()"></mat-select-trigger>
										<mat-option [value]="allUserRolesId" (click)="toggleAllRolesSelections()">Select All</mat-option>
										<mat-option *ngFor="let option of userRoles; trackById" [value]="option.Id" (click)="checkRoleOption()">
											{{ option.NameToDisplay }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
						</div>
					</form>
				</mat-tab>
			</mat-tab-group>
		</div>
		<footer class="linq-drawer-footer">
			<button type="button" mat-stroked-button color="primary" class="linq-button--secondary" (click)="closeFlyout()">Cancel</button>
			<span class="spacer"></span>
			<button *ngIf="matTabGroup.selectedIndex === 1" (click)="handleSubmitCopyToSites()" type="submit" mat-raised-button color="primary"
				[disabled]="selectedSiteCodeIds?.length < 1 || selectedUserRoleIds?.length < 1">
				Copy To Sites
			</button>
			<button *ngIf="matTabGroup.selectedIndex === 0" (click)="handleSubmitCopyAccountForm()" type="submit" mat-raised-button color="primary"
				[disabled]="copyAccountForm.invalid || sameAccountNumber()">
				Copy Account
			</button>
		</footer>
	</div>
</ng-template>